import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ed } from '../../lib/editTexts';

export default function PublicFooter() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <footer className="kac-footer">
      <span><span {...ed('footer.copyright')}>{t('footer.copyright')}</span> · <span {...ed('footer.founded')}>{t('footer.founded')}</span></span>
      <div className="kac-footer-links">
        <Link to="/support" className={pathname === '/support' ? 'active' : ''} {...ed('footer.support')}>{t('footer.support')}</Link>
        <Link to="/privacy" className={pathname === '/privacy' ? 'active' : ''} {...ed('footer.privacy')}>{t('footer.privacy')}</Link>
      </div>
    </footer>
  );
}
